import { render, staticRenderFns } from "./menu-tree.vue?vue&type=template&id=0a2b53e3&scoped=true"
import script from "./menu-tree.vue?vue&type=script&lang=js"
export * from "./menu-tree.vue?vue&type=script&lang=js"
import style0 from "./menu-tree.vue?vue&type=style&index=0&id=0a2b53e3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b53e3",
  null
  
)

export default component.exports